import { useConfig } from "../../context/config-context";

import Input from "./Input";

export const InputConfirmPassword = ({
  id,
  register,
  fieldName = "confirmPassword",
  password,
  error,
  hidebutton,
  label
}) => {
  const siteConfig = useConfig();

  return (
    <Input
      id={id}
      label={label || siteConfig.components.confirm_password.label}
      placeholder={siteConfig.components.confirm_password.placeholder}
      type="password"
      {...register(fieldName, {
        required: siteConfig.components.confirm_password.required,
        validate: (value) =>
          value === password || siteConfig.components.confirm_password.invalid,
      })}
      error={error}
      hidebutton={hidebutton}
    />
  );
};

export default InputConfirmPassword;
